module.exports = __webpack_public_path__ + "img/gwnu_gallery0.434b5b55.jpg";